import { jsx as _jsx } from "react/jsx-runtime";
import "./boot.js";
import { createRoot, hydrateRoot } from "react-dom/client";
import { SWRConfig } from "swr";
import App from "../App.js";
import { bumpEpoch, useEpoch } from "../lib/util.js";
import { recoverExpiredSession } from "../lib/session.js";
import { initFeaturesFromBrowser } from "../lib/features.js";
const root = document.getElementById("app");
if (!root) {
    throw new Error('Missing "#app" root element');
}
const build = root.getAttribute("data-build") ?? "dev";
const shouldHydrate = root.childNodes.length > 0;
if (!shouldHydrate) {
    initFeaturesFromBrowser();
}
const Root = () => {
    const epoch = useEpoch();
    return (_jsx(SWRConfig, { value: {
            provider: () => new Map(),
            onError: (error, key) => {
                if (recoverExpiredSession(error, key))
                    bumpEpoch();
            },
        }, children: _jsx(App, { ...(shouldHydrate ? { ssrPath: "/_blank" } : {}), build: build }) }, epoch));
};
if (shouldHydrate) {
    hydrateRoot(root, _jsx(Root, {}));
}
else {
    createRoot(root).render(_jsx(Root, {}));
}
